import { Controller } from "@hotwired/stimulus"

const FIELD = {
  shipDate: "milestoneShipDate",
  tracking: "milestoneTracking",
  carrierSelect: "milestoneCarrierSelect",
  website: "milestoneWebsite"
}

export default class extends Controller {
  static targets = [
    "milestoneShipDate",
    "milestoneTracking",
    "milestoneCarrierSelect",
    "milestoneWebsite",
    "milestoneCarrierHidden"
  ]

  toggleShipRow(event) {
    event.preventDefault()
    const milestoneId = event.currentTarget.dataset.milestoneId
    const row = this.element.querySelector(`#ship-row-${milestoneId}`)
    if (!row) return

    row.hidden = !row.hidden
    const link = event.currentTarget
    link.textContent = row.hidden ? link.dataset.defaultLabel : "Cancel"
  }

  copyToAll(event) {
    event.preventDefault()
    const sourceMilestoneId = event.currentTarget.dataset.milestoneId
    const sourceRow = this.element.querySelector(`#ship-row-${sourceMilestoneId}`)
    if (!sourceRow) return

    const values = this.readRow(sourceRow)
    this.shipRows().forEach((row) => {
      if (row === sourceRow || this.rowHasData(row)) return
      this.writeRow(row, values)
      this.revealRow(row)
    })
  }

  shipRows() {
    return Array.from(this.element.querySelectorAll('[id^="ship-row-"]'))
  }

  field(row, name) {
    return row.querySelector(`[data-shipping-details-target="${name}"]`)
  }

  // A row is "already filled" if the supplier put something in it. Tracking is the
  // shipment-step signal; a ship date counts too, unless the view marked it a placeholder
  // (the skip-confirmation shipment row pre-fills today's date, which "apply to all" may
  // overwrite — a date carried over from the PO, as on the invoice form, may not).
  rowHasData(row) {
    const tracking = this.field(row, FIELD.tracking)
    if (tracking?.value) return true

    const shipDate = this.field(row, FIELD.shipDate)
    if (!shipDate?.value) return false

    return shipDate.dataset.shippingDetailsPlaceholder !== "true"
  }

  readRow(row) {
    return {
      shipDate: this.field(row, FIELD.shipDate)?.value,
      tracking: this.field(row, FIELD.tracking)?.value,
      carrierSelect: this.field(row, FIELD.carrierSelect)?.value,
      website: this.field(row, FIELD.website)?.value
    }
  }

  writeRow(row, values) {
    this.setField(row, FIELD.shipDate, values.shipDate)
    this.setField(row, FIELD.tracking, values.tracking)
    this.setCarrier(row, values.carrierSelect)
    if (values.website) this.setField(row, FIELD.website, values.website)
  }

  setField(row, name, value) {
    if (value === undefined) return
    const el = this.field(row, name)
    if (el) el.value = value
  }

  setCarrier(row, value) {
    if (value === undefined) return
    const carrierSelect = this.field(row, FIELD.carrierSelect)
    if (!carrierSelect) return

    carrierSelect.value = value
    carrierSelect.dispatchEvent(new Event("change", { bubbles: true }))
  }

  revealRow(row) {
    if (!row.hidden) return

    row.hidden = false
    const otherId = row.id.replace("ship-row-", "")
    const link = this.element.querySelector(`[data-milestone-id="${otherId}"][data-action*="toggleShipRow"]`)
    if (link) link.textContent = "Cancel"
  }
}
